import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { SpinnerModule } from 'primeng/spinner';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { KeyFilterModule } from 'primeng/keyfilter';
//import {  FileUploadModule, InputMaskModule, ColorPickerModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/radiobutton';
import { WhItemMastComponent } from './whItemmast/vista/whItemmast-listado.component';
import { WhItemDetalleComponent } from './whItemmast/vista/whitemmast-detalle.component';
import { WhAlmacenmastService } from './whalmacenmast/servicio/whalmacenmast.servicio';
import { WhItemMastServicio } from './whItemmast/servicio/WhItemMast.service';
import { WhItemInventarioComponent } from './whItemmast/vista/whitemmast-inventario.component';
import { WhTransaccionService } from './whtransaccion/servicio/whtransaccion.servicio';
import { WhGuiaService } from './whguia/servicio/whguia.servicio';
import { WhItemNuevoMastComponent } from './whItemmast/vista/whItemmast-listado-nuevo.component';
import { WhItemDetalleNuevoComponent } from './whItemmast/vista/whitemmast-detalle-nuevo.component';

@NgModule({
    declarations: [
        WhItemMastComponent,
        WhItemDetalleComponent,
        WhItemInventarioComponent,
        WhItemNuevoMastComponent,
        WhItemDetalleNuevoComponent
    ],
    imports: [CommonModule,
        //InputMaskModule,
        FormsModule,
        TableModule, PanelModule,  BlockUIModule,
        InputTextModule, ButtonModule, DropdownModule,
        SpinnerModule, CalendarModule, CheckboxModule,
        ConfirmDialogModule, TabViewModule, FieldsetModule,
        //FileUploadModule,
         KeyFilterModule,
        DialogModule, RadioButtonModule,        
        //ColorPickerModule
    ],
    exports: [WhItemNuevoMastComponent,WhItemDetalleNuevoComponent],
    providers: [
        ConfirmationService,
        WhAlmacenmastService,
        WhItemMastServicio,
        WhTransaccionService,
        WhGuiaService  
    
    ],
})
export class LogisticaModule { }
